/* eslint-disable @typescript-eslint/no-require-imports */
import React from 'react';
import Header from './Header';
import MarkdownFromFile from './MarkdownFromFile';
import appStyles from './styles';

require('./main.css');

const App: React.FC = () => {
  return (
    <div style={appStyles.wrapper}>
      <div style={appStyles.header}>
        <Header />
      </div>
      <div style={appStyles.content}>
        <div
          style={{
            margin: 'auto',
            height: '100%',
          }}
        >
          <MarkdownFromFile />
        </div>
      </div>
    </div>
  );
};

export default App;
